
import { Component, Prop } from 'vue-property-decorator'
import Axios, { CancelTokenSource } from 'axios'
import { TERMS_PARAM, PAGE_PARAM } from '../helpers/constants'
import Mixin from '../helpers/mixin'
import { IAggregation, IFilterItem, Sorting } from '../helpers/types'

@Component({
  template: `
  <div v-if='aggregations.length'>
    <button class='hidden-desktop hidden-tablet-l flex filter__open-button' @click='openFilters()'>
      <i class="icons8-slider mr-05"></i>
      {{ phoneTitle }}
      <div class='filter__counter-container' v-if='countSelectedFilter > 0'>
        <div class='ml-05 filter__count'>{{ countSelectedFilter }}</div>
      </div>
    </button>

    <transition name='filter-from-left'>
      <div class='filter' v-if='!isPhoneAndTablet || opened'>
        <button class='hidden-desktop hidden-tablet-l filter__close-button' @click='closeFilter()'>
          <i class="icons8-delete"></i>
        </button>
        <div class='filter__overflow'>
          <h3 class='flex-align-center filter__header'>
            <i class="icons8-slider mr-05"></i>
            {{ visibleTitle }}
          </h3>

          <sort-and-size-dropdowns
            :sorting-names='sortingNames'
            :product-label='productLabel'
            :add-filter-class='true'
            :on-phone='true'>
          </sort-and-size-dropdowns>

          <div class='filter__remove' v-if='anyFiltersSelected' @click='unselectAll()'>
            <i class="icons8-delete mr-025"></i>
            {{ removeAllText }}
          </div>

          <expand-item  v-for='(aggregation, aggrIndex) in aggregations' extra-margin='20' :title='aggregation.label' :initial-open="openExpandItem(aggregation, aggrIndex)" :key='aggregation.label + aggrIndex'>
            <div class='filter__checkbox' v-for='(item, itemIndex) in aggregation.items'>
              <input :id='aggregation.label + "-" + item.label' type='checkbox' v-model='item.isApplied' @click='onFiltersChange' :value='item.isApplied'>
              <label :for='aggregation.label + "-" + item.label'>{{ getDisplayLabel(item.label) }}</label>
            </div>
          </expand-item>
        </div>
      </div>
    </transition>

    <transition name='fade'>
      <div v-if='$store.state.showContentOverlay && isPhoneAndTablet'
        @click='$store.state.onOverlayClick ? $store.state.onOverlayClick() : null'
        class='gray-content-overlay'
        v-cloak>
      </div>
    </transition>
  </div>
  `
})
export default class Filters extends Mixin {
  @Prop({ default: () => [] }) aggregations: IAggregation[]
  @Prop({ default: 'Filters' }) title: string
  @Prop({ default: 'Alles wissen' }) removeAllText: string
  @Prop({ default: 'Filters en sortering' }) phoneTitle: string
  @Prop({ default: true }) filtersOpen: boolean
  @Prop({ default: [{displayname:'Relevance', param: 'priority' }] }) sortingNames: Sorting[]
  @Prop({ default: 'product' }) productLabel: string

  getProductsTimer: any = null
  cancelTokenSource: CancelTokenSource | null = null
  loading = false
  opened = false

  params = new URLSearchParams(window.location.search)

  get visibleTitle(): string {
    return this.isPhoneAndTablet ? this.phoneTitle : this.title
  }

  get anyFiltersSelected(): boolean {
    return this.aggregations
      .filter((aggregation) => aggregation.items.some((item) => item.isApplied)).length > 0
  }

  openExpandItem(aggregation: any, index: number): boolean {
    if (!this.filtersOpen && !this.anyFiltersSelected) return false
    if (this.anyFiltersSelected) return aggregation.items.some((item: any) => item.isApplied)
    return (index < 1)
  }

  get countSelectedFilter(): number {
    let result = 0

    this.aggregations.forEach(aggr => result += aggr.items.filter(item => item.isApplied).length)
    return result
  }

  getDisplayLabel(originalLabel: string): string {
    const labelLowercase = originalLabel.toLowerCase()
    return labelLowercase === 'true' ||  labelLowercase === 'false' ? this.$options?.filters?.t(`${labelLowercase}Label`) : originalLabel
  }

  openFilters(): void {
    this.opened = true
    this.$store.commit('openContentOverlay', this.closeFilter)
  }

  closeFilter(): void {
    this.opened = false
    this.$store.commit('closeContentOverlay')
  }

  onFiltersChange(item: IFilterItem): void {
    item.isApplied = !item.isApplied
    if (this.getProductsTimer) clearTimeout(this.getProductsTimer)
    this.getProductsTimer = setTimeout(() => {
      this.getProducts()
    }, 750)
  }

  unselectAll() {
    this.aggregations.forEach(aggr => aggr.items.forEach(item => item.isApplied = false))
    this.getProducts()
  }

  // TODO (HAKB2B-699) change get to fetch all products and set the history of window to avoid reload page
  async getProducts(): Promise<void> {
    this.loading = true
    if (this.cancelTokenSource) this.cancelTokenSource.cancel()
    this.cancelTokenSource = Axios.CancelToken.source()
    this.setSearchQuery()
  }

  setSearchQuery() {
    const terms = this.aggregations
      .filter((aggregation) => aggregation.items.some((item) => item.isApplied))
      .map(
        (aggregation) =>
          `${aggregation.field}:${aggregation.items
            .filter((item) => item.isApplied)
            .map((item) => item.value.replace(/,/g, '_comma_'))
            .join(',')}`
      )
      .join(';')
    this.updateParam(TERMS_PARAM, terms)
  }

  updateParam(key: string, value: string){
    if(this.params.has(PAGE_PARAM)) this.params.delete(PAGE_PARAM)

    if(value === ''){
      if (this.params.has(key)) this.params.delete(key)
    }
    else if (this.params.has(key)) {
      this.params.set(key, value)
    }
    else {
      this.params.append(key, value)
    }

    window.location.href = this.createUrl()
  }

  createUrl(){
    const paramsString = this.params.toString()
    return window.location.origin + window.location.pathname + (paramsString !== '' ?  '?' + paramsString : '')
  }
}
